// removed by extract-text-webpack-plugin
module.exports = {"loading":"Loading__loading___1fvBF6x","circle":"Loading__circle___1ezvvmg","jump":"Loading__jump___ep9KbTU"};